export const isTrue = (value) => {
  return value === true || value === "true";
};

export const handleNavigate = (path, hash, navigate) => {
  navigate(path);
  setTimeout(() => {
    const section = document.querySelector(hash);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  }, 0);
};

// Function to convert HTML to plain text
const stripHtmlAndStyles = (html) => {
  const div = document.createElement("div");
  div.innerHTML = html;
  return div.textContent || div.innerText || "";
};

// Function to apply character limit without counting HTML tags or styles
export const charLimit = (html, limit) => {
  const plainText = stripHtmlAndStyles(html); // Remove HTML tags and styles
  return plainText?.length > limit
    ? plainText.substring(0, limit + 1) + "..." || "---"
    : plainText;
};

export const createArrayUpto = (number) => {
  return [...Array(number)];
};

export function collectIds(data) {
  const ids = [];

  function traverse(item) {
    if (item && item._id) {
      ids.push(item._id); // Add the current _id to the array
      if (item._parent) {
        traverse(item._parent); // Recursively traverse the parent
      }
    }
  }

  traverse(data?._parent);
  ids.push(data?.admin?._user);
  // console.log(ids,"IDS");

  return ids;
}

export const extractedUrlPath = (url) => {
  if (!url || !url.includes(".com/")) return "";
  return url.split(".com/")[1] || "";
};
// below chat section
// //--------in-use-message-list--it-is-check-link-or-text------------------
// export const isLink = (message) => {
//   if (!message) return '';
//   const urlPattern = /(https?:\/\/[^\s]+)/gi;
//   const urlMatch = message.match(urlPattern);

//   if (urlMatch) {
//     return <Microlink
//       url={urlMatch[0]}
//       // size="large"
//       // media="image"
//       // media='logo'
//       target="_blank"
//     />;
//   } else {
//     return <p>{message}</p>;
//   }
// };

// // ---------handle-preview-file-image-or-pdf----in-chat-section------------
// export const previewFiles = (url) => {
//   if (!url) return null;

//   const fileExtension = url.split('.').pop().toLowerCase();
//   const isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'png'].includes(fileExtension);
//   const isPDF = fileExtension === 'pdf';

//   if (isImage) {
//     return <img className="pastImage" src={url} alt="attachment preview" />;
//   } else if (isPDF) {
//     return <BsFilePdf size={50} color="red" />;
//   } else {
//     return <p>Unsupported file type</p>;
//   }
// };
// //-------------reply-preview-only-file---image-or-pdf-----------------
// export const renderReplyAttachment = (url) => {
//   if (!url) return null
//   const fileExtension = url?.split(".").pop().toLowerCase();
//   const isImage = ["jpg", "jpeg", "png", "gif", "webp"].includes(fileExtension);
//   const isPDF = fileExtension === "pdf";

//   if (isImage) {
//     return (
//       <img
//         src={url}
//         alt="reply"
//         style={{
//           maxWidth: "100px",
//           borderRadius: "6px",
//           marginTop: "4px",
//           cursor: "pointer",
//         }}
//       // onClick={() => handleViewProfile(file.url)}
//       />
//     );
//   } else if (isPDF) {
//     return (
//       <div
//         // onClick={() => handleViewProfile(file.url)}
//         style={{ marginTop: "5px", cursor: "pointer" }}
//       >
//         <BsFilePdf size={30} color="red" title="PDF Preview" />
//       </div>
//     );
//   }

//   return (
//     <div style={{ fontSize: "0.8em", color: "#999" }}>
//       Unsupported attachment
//     </div>
//   );
// };